import * as React from 'react';
import { Component, createContext } from 'react';
import SpatialNavigationWrapper from './SpatialNavigationWrapper';

export const NavigationContext = createContext({});

class WithNavigation extends Component {
  componentDidMount() {
    SpatialNavigationWrapper.init();
  }

  componentWillUnmount() {
    SpatialNavigationWrapper.destroy();
  }

  setFocus = focusPath => {
    if (SpatialNavigationWrapper.getCurrentFocusedPath() !== focusPath) {
      SpatialNavigationWrapper.setCurrentFocusedPath(focusPath);
    }
  };

  render() {
    const { children } = this.props;

    return (
      <NavigationContext.Provider value={{ setFocus: this.setFocus }}>
        {children}
      </NavigationContext.Provider>
    );
  }
}

export default WithNavigation;
